import { __assign } from "tslib";
import { getFrame } from './project';
import * as deviceFrames from '../constants/deviceFrames';
export function getDocumentHeadProps(state) {
    var _a, _b;
    var isLoading = state.project.isLoading;
    if (isLoading) {
        return { isLoading: isLoading };
    }
    return __assign(__assign({ projectID: state.project.config.id, projectTitle: state.project.config.name, screenName: (_b = (_a = state.screen) === null || _a === void 0 ? void 0 : _a.currentScreen) === null || _b === void 0 ? void 0 : _b.name }, state.project.config), { viewportFitCover: getFrame(state) === deviceFrames.IPHONE_X });
}
